(function () {
  var WRAPPER_SELECTOR = '.product-card-wrapper';
  var HEADING_SELECTOR = '.card__content .card__information > .card__heading';
  var resizeTimer;

  function getVisibleElements(selector) {
    var elements = [];
    document.querySelectorAll(WRAPPER_SELECTOR).forEach(function (wrapper) {
      wrapper.querySelectorAll(selector).forEach(function (element) {
        if (element.offsetParent !== null) {
          elements.push(element);
        }
      });
    });
    return elements;
  }

  function setEqualHeightByRow(elements) {
    var rows = {};

    elements.forEach(function (element) {
      element.style.minHeight = '';
      var rowKey = Math.round(element.getBoundingClientRect().top);
      if (!rows[rowKey]) rows[rowKey] = [];
      rows[rowKey].push(element);
    });

    Object.keys(rows).forEach(function (rowKey) {
      var rowElements = rows[rowKey];
      var maxHeight = 0;

      rowElements.forEach(function (element) {
        maxHeight = Math.max(maxHeight, element.offsetHeight);
      });

      rowElements.forEach(function (element) {
        element.style.minHeight = maxHeight + 'px';
      });
    });
  }

  function syncNow() {
    setEqualHeightByRow(getVisibleElements(HEADING_SELECTOR));
  }

  function sync() {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(syncNow);
    });
  }

  function debouncedSync() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(sync, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  window.addEventListener('load', sync);
  window.addEventListener('resize', debouncedSync);
  window.addEventListener('orientationchange', debouncedSync);
  document.addEventListener('shopify:section:load', debouncedSync);
  document.addEventListener('shopify:section:reorder', debouncedSync);

  window.ProductCardHeadingHeights = {
    sync: sync,
    debouncedSync: debouncedSync
  };
})();
